import { render, staticRenderFns } from "./ReviewRequestAmbulatoryRecordDetails.vue?vue&type=template&id=674c2a88&scoped=true&"
import script from "./ReviewRequestAmbulatoryRecordDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewRequestAmbulatoryRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequestAmbulatoryRecordDetails.vue?vue&type=style&index=0&id=674c2a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c2a88",
  null
  
)

export default component.exports